export type QuestionnaireEvidence={event:string;handler:string;proof:string;changes:string[];accepted:false;status:'pending'};
/** Literal click branches and literal state assignments only. Never execute, import or stringify executable source into a template. */
export function questionnaireEvidence(source:string):QuestionnaireEvidence[]{
 if(source.length>5*1024*1024)return [];
 const expected:Record<string,string>={'start-series':'startQuiz',pick:'pick',submit:'submit',next:'nextQuestion',again:'startQuiz'};
 const output:QuestionnaireEvidence[]=[];
 for(const [event,handler] of Object.entries(expected)){
  const escaped=event.replace(/-/g,'\\-');
  const pattern=new RegExp("(?:if|else if)\\s*\\(action === '"+escaped+"'\\)\\s*(?:\\{[^{}\\r\\n]{0,120})?"+handler+"\\(");
  const match=source.match(pattern);if(!match||!source.includes('function '+handler+'('))continue;
  const start=source.indexOf('function '+handler+'('),next=source.indexOf('\n  function ',start+10);
  const body=source.slice(start,Math.min(start+4000,next<0?source.length:next));
  const changes=[...body.matchAll(/\b(?:selected|viewedResult)\s*=\s*(?:null|original|state\.session)\s*;|\bnavigate\(\s*'(?:quiz|result)'\s*\)/g)].map(item=>item[0]);
  output.push({event,handler,proof:match[0].slice(0,250),changes,accepted:false,status:'pending'});
 }
 return output;
}
